import api from './api';

const onboardingService = {
  // Create company with trial
  createCompany: async (companyData) => {
    try {
      const response = await api.post('/onboarding/company', companyData);
      return {
        success: true,
        data: response.data
      };
    } catch (error) {
      return {
        success: false,
        error: error.response?.data?.message || 'Failed to create company'
      };
    }
  },

  // Get available plans
  getPlans: async () => {
    try {
      const response = await api.get('/onboarding/plans');
      return {
        success: true,
        data: response.data.plans
      };
    } catch (error) {
      return {
        success: false,
        error: error.response?.data?.message || 'Failed to fetch plans'
      };
    }
  },

  // Get plans by country
  getPlansByCountry: async (countryId) => {
    try {
      const response = await api.get(`/onboarding/plans?country=${countryId}`);
      return {
        success: true,
        data: response.data.plans
      };
    } catch (error) {
      return {
        success: false,
        error: error.response?.data?.message || 'Failed to fetch plans for country'
      };
    }
  },

  // Get available countries
  getCountries: async () => {
    try {
      const response = await api.get('/onboarding/countries');
      return {
        success: true,
        data: response.data.countries
      };
    } catch (error) {
      return {
        success: false,
        error: error.response?.data?.message || 'Failed to fetch countries'
      };
    }
  },

  // Get available industries
  getIndustries: async () => {
    try {
      const response = await api.get('/onboarding/industries');
      return {
        success: true,
        data: response.data.industries
      };
    } catch (error) {
      return {
        success: false,
        error: error.response?.data?.message || 'Failed to fetch industries'
      };
    }
  },

  // Get custom fields for an industry
  getIndustryCustomFields: async (industryId, module) => {
    try {
      const response = await api.get(`/onboarding/industries/${industryId}/custom-fields`, {
        params: { module }
      });
      return {
        success: true,
        data: response.data
      };
    } catch (error) {
      return {
        success: false,
        error: error.response?.data?.message || 'Failed to fetch custom fields'
      };
    }
  }
};

export default onboardingService;